/*       */

import React from 'react';
import styled from 'styled-components';

const TooltipStyled = styled.div`
    position: relative;
    [alt]::after {
        content: attr(alt);
        position: absolute;
        transform: translateX(${({ x }) => (x || x === 0 ? x : -50)}%) translateY(${({ y }) => (y || y === 0 ? y : -100)}%);
        background: ${({ theme }) => theme.material.colors.background.default};
        text-align: center;
        color: ${({ theme }) => theme.material.colors.text.primary};
        padding: 4px 2px;
        font-size: 12px;
        border-radius: 5px;
        border: 1px solid ${({ theme }) => theme.material.colors.background.tooltipBorder};
        pointer-events: none;
        padding: 4px 4px;
        z-index: 99;
        opacity: 0;
        margin-left: -10px;
        white-space: ${({ nowrap }) => (nowrap ? 'nowrap' : 'normal')};
    }
    [alt]:hover::after,
    [alt]:hover::before {
        opacity: 1;
    }
`;

const Tooltip = ({ children, x, y, nowrap, ...restProps }) => {
    return (
        <TooltipStyled x={x} y={y} nowrap={nowrap} {...restProps}>
            {children}
        </TooltipStyled>
    );
};

export default Tooltip;
